export default __webpack_public_path__ + "87950fd1d33e5d77cf1f87ac9564ddb7.png";